<template>
  <div id="page">

    <div id='card_p' class="row topCardGrid" v-if="false">
      <sp-card :valor="solicitacoes156.abertas" :descricao="$t('eixos.urbano.topCards.solicitacoes156title')" classDesc="pull-right" :lgGrid="3"
        :mdGrid="3" stripe=' ' :footerText="$t('eixos.urbano.topCards.solicitacoes156footer') + dataEstoque156"
        icon="fa fa-line-chart boldness "></sp-card>
      <sp-card :valor="tapaBuraco.recebidas" :descricao="$t('eixos.urbano.topCards.tapaBuracoTitle')"
        classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' '
        :footerText="$t('eixos.urbano.topCards.tapaBuracoFooter') + formatadorNumero(tapaBuraco.media_atendimento_dias) + ' dias'" icon="fa fa-road boldness "></sp-card>
      <sp-card :valor="canalDeEntrada" :descricao="canalDeEntradaPrincipal.de_canal" classDesc="pull-right" :lgGrid="3"
        :mdGrid="3" stripe=' ' :footerText="$t('eixos.urbano.topCards.canalEntradaFooter')"
        icon="fa fa-tachometer boldness "></sp-card>
      <sp-card valor="1.length" :descricao="$t('eixos.urbano.topCards.medicamentosTitle')" classDesc="pull-right"
        :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.urbano.topCards.medicamentosFooter')"
        icon="fa fa-medkit boldness "></sp-card>
    </div>

    <div id='card_s' class="row topCardGrid">
      <sp-card :valor="municipio.recebidas" :descricao="$t('eixos.urbano.topCards.servicosZeladoriaCard')" classDesc="pull-right"
        :lgGrid="3" :mdGrid="3" stripe=' ' :footerText="$t('eixos.urbano.topCards.solicitacoes156footer') + dataEstoque156"
        icon="fa fa-bullhorn boldness "></sp-card>

      <sp-card valor="R$1,95" sufix="Mi" :descricao="$t('eixos.urbano.topCards.auxilioAluguelCard')"
        classDesc="pull-right" :lgGrid="3" :mdGrid="3" stripe=' '
        :footerText="$t('eixos.urbano.topCards.auxilioAluguelFooter')" icon="fa fa-money boldness "></sp-card>

      <sp-card valor="107" :descricao="$t('eixos.urbano.topCards.parquesMunicipaisCard')" classDesc="pull-right" :lgGrid="3"
        :mdGrid="3" stripe=' ' :footerText="$t('eixos.urbano.topCards.parquesMunicipaisFooter')"
        icon="fa fa-tree boldness "></sp-card>

       <sp-card valor="1.118" :descricao="$t('eixos.urbano.topCards.pracasAdotasCard')" classDesc="pull-right" :lgGrid="3"
        :mdGrid="3" stripe=' ' :footerText="$t('eixos.urbano.topCards.pracasAdotasFooter')"
        icon="fa fa-handshake-o boldness "></sp-card>

    </div>

    <div id="listas" class="row">
      <div class="flex lg6 md6 sm12">
        <sp360-list fit :title="$t('eixos.urbano.lists.titleList1')" :image="working" :footerComplementar="$t('eixos.urbano.lists.titleList1Rodape')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <template v-for="(m, index) in lista1" class="list">
            <va-item>
              <va-item-section>
                <va-item-label>
                  {{m.servico_desc}}
                </va-item-label>
                <va-item-label caption>
                   {{listaCaption(m)}}
                </va-item-label>
              </va-item-section>
            </va-item>
            <va-list-separator v-if="index < lista1.length-1" />
          </template>
          <va-button :v-show="showbuttom1()" outline color="danger" class="pull-right"  @click="openModalLista1($event)">
            {{$t('eixos.urbano.lists.buttonList1')}}
          </va-button>
          <br>
        </sp360-list>
      </div>
      <div class="flex lg6 md6 sm12">
        <sp360-list fit :title="$t('eixos.urbano.lists.titleList2')" :image="skyscrapers" :footerComplementar="$t('eixos.urbano.lists.titleList2Rodape')" :footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})">
          <template v-for="(m, index) in lista2" class="list">
            <va-item>
              <va-item-section>
                <va-item-label>
                  {{m.nome}}
                </va-item-label>
                <va-item-label caption>
                  {{listaCaption(m)}}
                </va-item-label>
              </va-item-section>
            </va-item>
            <va-list-separator v-if="index < lista2.length-1" />
          </template>
          <va-button v-show="showbuttom2()" outline color="danger" class="pull-right"  @click="openModalLista2($event)">
            {{$t('eixos.urbano.lists.buttonList2')}}
          </va-button>
          <br>
        </sp360-list>
      </div>
    </div>

    <div id="bottom" class="row" v-if="false">
      <div class="flex md4 lg4 sm12 inside">
        <sp-360-panel :title="$t('eixos.urbano.bottomPanels.tituloPainel1')" :footerText="$t('eixos.urbano.bottomPanels.rodapePainel1')">

        </sp-360-panel>
      </div>
      <div class="flex md4 lg4 sm12 inside">
        <sp-360-panel :title="$t('eixos.urbano.bottomPanels.tituloPainel2')" :footerText="$t('eixos.urbano.bottomPanels.rodapePainel2')">

        </sp-360-panel>
      </div>
      <div class="flex md4 lg4 sm12 inside">
        <sp-360-panel :title="$t('eixos.urbano.bottomPanels.tituloPainel3')" :footerText="$t('eixos.urbano.bottomPanels.rodapePainel3')">

        </sp-360-panel>
      </div>
    </div>

    <div id="modals">
      <va-modal show.sync="true" ref="modalLista1" :okText="$t('modal.close')" :okClass="'btn btn-primary btn-sm'"
        size="large" v-model="showModalLista1" :title="$t('eixos.urbano.modal.zeladoria')" :cancelText="''">
        <template slot="default">
          <sp360-data-table id="tabelaEstoqueMedicamentos" ref="tabelaEstoqueMedicamentos" :data="listaTabela1"
            :fields="camposTabelaLista1" :perPage="itemsPerPage" :onEachSide="onEachSide"
             />
        </template>
      </va-modal>
      <va-modal ref="modalLista2" :okText="$t('modal.close')" :okClass="'btn btn-primary btn-sm'" :cancelText="''"
        size="large" v-model="showModalLista2" :title="$t('eixos.urbano.modal.zeladoriaPorSub')">
        <template slot="default">
          <sp360-data-table id="tabelaEstoqueMedicamentos" ref="tabelaEstoqueMedicamentos" :data="listaTabela2"
            :fields="camposTabelaLista2" :perPage="itemsPerPage" :onEachSide="onEachSide"
            />
        </template>
      </va-modal>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import MethGlob from '@/utils/MetodosGlobais'
import Constantes from '@/utils/ConstantesGlobais'
import Donut from '@/components/statistics/charts/GraficoDonut.vue'
import CorUtils from '@/utils/CorUtils'

import SpCard from '@/components/ui/cards/SP360Card'
import Sp360Chart from '@/components/ui/chart/sp360chart'
import Sp360Panel from '@/components/ui/sp360-panel/sp360-panel'
import SPMapaNomes from '@/utils/SPMapaNomes'
import Sp360DataTable from '@/components/ui/dataTable/sp360datatable'
import Sp360List from '@/components/ui/list/VaList'

import working from '@/assets/images/zeladoria.jpg'
import skyscrapers from '@/assets/images/sao.jpg'

export default {
  name: 'eixo-urbano',
  components: {
    Donut,
    SpCard,
    Sp360Chart,
    Sp360Panel,
    Sp360DataTable,
    Sp360List,
    Constantes,
    skyscrapers,
    working,
  },
  data () {
    return {
      tapaBuraco: 0,
      solicitacoes156: 0,
      dataEstoque156: 0,
      servicosPorRegiao: [],
      canaisDeEntrada: [],
      canalDeEntradaPrincipal: {},
      municipio: {},

      // IMG
      working: working,
      skyscrapers: skyscrapers,

      // Tabelas dos Modais

      onEachSide: 1,

      lista1: [],
      lista2: [],
      showModalLista1: false,
      showModalLista2: false,

      listaTabela1: [],
      listaTabela2: [],
      itemsPerPage: Constantes.PARAMETROS_DASHBOARD.SAUDE.ESTOQUE_MEDICAMENTOS.TAMANHO_TABELAS,

      camposTabelaLista1: [

        {
          name: 'servico_desc',
          sortField: 'servico_desc',
          title: this.$t('mainDashboard.tableFields.servicos'),
          width: '54%',
        },
        {
          name: 'recebidas',
          sortField: 'recebidas',
          title: this.$t('mainDashboard.tableFields.recebidas'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
        {
          name: 'finalizadas',
          sortField: 'finalizadas',
          title: this.$t('mainDashboard.tableFields.finalizadas'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
        {
          name: 'media_atendimento_dias',
          sortField: 'media_atendimento_dias',
          title: this.$t('mainDashboard.tableFields.TMA'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
      ],

      camposTabelaLista2: [
        {
          name: 'nome',
          sortField: 'nome',
          title: 'subPrefeitura',
          width: '12%',
        },
        {
          name: 'recebidas',
          sortField: 'recebidas',
          title: this.$t('mainDashboard.tableFields.recebidas'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
        {
          name: 'finalizadas',
          sortField: 'finalizadas',
          title: this.$t('mainDashboard.tableFields.finalizadas'),
          callback: MethGlob.thousandSeparator,
          width: '6%',
        },
      ],

      sortFunctionsCamposTabelaLista1: {
        'servico_desc': MethGlob.ordenaTabela,
        'recebidas': MethGlob.ordenaTabela,
        'finalizadas': MethGlob.ordenaTabela,
        'media_atendimento_dias': MethGlob.ordenaTabela,

      },

      sortFunctionsCamposTabelaLista2: {
        'nome': MethGlob.ordenaTabela,
        'recebidas': MethGlob.ordenaTabela,
        'finalizadas': MethGlob.ordenaTabelaParseInt,
      },
      //......
      fonte: '',
      dataRef: '',
      //......
    }
  },
  created () {
    Promise.all([
      this.$store.dispatch('servicos156/buscarSolicitacoesPorCanal'),
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: Constantes.PARAMETROS_DASHBOARD.SP156.QTD_SERVICOS_POR_REGIAO_ULTIMO_MES_REQUEST, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas' }),
      this.$store.dispatch('servicos156/buscarEvolucaoEstoqueSolicitacao', { agrupamento: 'MENSAL' }),
      this.$store.dispatch('servicos156/buscarTopPorRegiao', { topReqs: 20, intervalo: 'ULTIMO_MES', ordenacao: 'recebidas', filtroId: '2641,1071,952,2655,938,1037,3630,945,811,3113,3458,743,814,3732,3255,915,720,3039,950,745,931,773,774,747,3179,3813,3137,1002,752,958,965,779,778,766,966,3381,3178,758,1000,927, 939, 951' }),
    ]).then(respostas => {
      //{fonte: fonte, data: dataRef}
      //:footerText="$t('rodape.fonteData', {fonte: fonte, data: dataRef})"
      this.fonte = respostas[0].data.sigla_orgao + '-' + respostas[0].data.fonte
      this.dataRef = new Date(respostas[0].data.data_referencia_dado).toLocaleDateString('pt-BR')
      this.ref = this.$t('rodape.fonteData', { fonte: this.fonte, data: this.dataRef })

      this.canaisDeEntrada = _.orderBy(respostas[0].data.data, ['historico[0].perc_mes'], ['desc'])
      this.canalDeEntradaPrincipal = this.canaisDeEntrada[0]
      this.servicosPorRegiao = respostas[1].data.data
      this.zeladoria = _.orderBy(respostas[3].data.data, ['recebidas'], ['desc'])
      this.municipio = this.zeladoria.shift()
      this.lista1 = this.municipio.servicos.slice(0, 8)
      this.lista2 = this.zeladoria.slice(0, 8)
      this.listaTabela1 = this.municipio.servicos // this.servicosPorRegiao[0].servicos
      this.listaTabela2 = this.zeladoria
      this.tapaBuraco = _.find(this.servicosPorRegiao[0].servicos, { 'servico_desc': 'Tapa-buraco' })
      this.solicitacoes156 = respostas[2].data.data[respostas[2].data.data.length - 1]
      this.dataEstoque156 = new Date(this.solicitacoes156.data_estado_estoque).toLocaleDateString()
    })
  },

  computed: {
    canalDeEntrada () {
      return this.canalDeEntradaPrincipal.historico ? MethGlob.formataPercentual(this.canalDeEntradaPrincipal.historico[0].perc_mes, null, null, '%') : 0
    },
  },

  methods: {
    rodapeData (d, data) {
      return MethGlob.rodapeData(d, data)
    },

    formatadorNumero (v) {
      return v ? v.toFixed(0) : 0
    },

    formatadorPercentual (v, sufix) {
      return v ? MethGlob.formataPercentual(v, null, null, sufix || '') : 0
    },

    openModalLista1 () { this.showModalLista1 = !this.showModalLista1 },

    openModalLista2 () { this.showModalLista2 = !this.showModalLista2 },

    filtrarLista1 () { return this.tabelaLista1 },

    filtrarLista2 () { return this.tabelaLista2 },

    listaCaption: function (m) {
      return `Solicitações Recebidas ${MethGlob.thousandSeparator(m.recebidas)} | Solicitações Concluídas ${MethGlob.thousandSeparator(m.finalizadas)}`
    },

    showbuttom1 () {
      return (this.lista1.length < this.listaTabela1.length)
    },

    showbuttom2 () {
      return (this.lista2.length < this.listaTabela2.length)
    },

    zeladoriaContagem () {
      let c = 0
      this.zeladoria.forEach((sub) => {
        sub.servicos.forEach((servico) => {
          c += servico.recebidas
        })
      })
      return c
    },

  },
}
</script>

<style lang="scss" scoped>
  .img-card {
    .va-card__image{
        padding-bottom: 20% !important;
    }
  }

  .list {
    padding: 0.02rem
  }

  .boldness{
      font-size: 2.5vw;
      font-weight: 900;
      @include media-breakpoint-down(sm) {
        font-size: 7.5vw;
      }
  }

  .enfase{
      font-size: 1rem;
      font-weight: 900;
  }

  .va-chart{
    max-height:20.8rem ;
  }

</style>
